export default "__VITE_ASSET__0f9b86ef__"